"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTileBadge = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const product_tile_badge_constants_1 = require("./product-tile-badge.constants");
const product_tile_badge_styles_1 = require("./product-tile-badge.styles");
const ProductTileBadge = ({ type }) => (react_1.default.createElement(product_tile_badge_styles_1.StyledBadgeWrapper, { className: (0, classnames_1.default)({
        updated: type === product_tile_badge_constants_1.BADGE_TYPE.UPDATED,
    }) }, type));
exports.ProductTileBadge = ProductTileBadge;
